function About() {
  return (
    <div>
      <h1>APOD app</h1>
      <p>Aplicando os conhecimentos do curso.</p>
    </div>
  )
}

export default About
